export default __webpack_public_path__ + "static/toolbar-feature-flags-dark-mode-fb073f45eea8bcf90bb8230b5db40d73.mp4";